import React from "react";
import smiley from "assets/smily.png";
import CTA from "components/CTA";

const HomeWillInfo2 = () => (
	<div
		id="home-who"
		className="px-8 md:px-36 py-16 md:py-28 text-center bg-teal flex justify-center text-center text-white dark:text-white"
	>
		<div className="w-[70%] my-16 flex gap-8 flex-col">
			<div className="flex justify-center">
				<img className="w-[60px] h-[60px] relative" alt="smiley" src={smiley} />
			</div>
			<h2 className="font-bold text-white">
				Who should you make a power of attorney.
			</h2>
			<h3 className="text-white font-bold">That’s completely up to you.</h3>
			<div>
				<p className="text-white">
					You probably don&apos;t want to pick someone who isn&apos;t calm under
					pressure, or the one who disappears when it is their time to pay for a
					round.
				</p>
			</div>
			<div className="mt-4">
				<CTA title="Choose your people" />
			</div>
		</div>
	</div>
);

export default HomeWillInfo2;
